import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/cart/customers')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/_authenticated/cart/customers"!</div>;
}
